"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/workspace/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _ethers = require("ethers"),
    _methodRegistry = _interopRequireDefault(require("./lib/methodRegistry")),
    _lib = require("../lib/"),
    _data = require("../data/"),
    _defaults = require("../defaults");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var makeUnknownFunctionNode = function makeUnknownFunctionNode(methodId) {
  return {
    type: "string",
    value: "Unknown function (".concat(methodId, ")")
  };
},
    parse = function parse(signature) {
  var fragment = _ethers.ethers.utils.FunctionFragment.from(signature);

  return {
    name: fragment.name.charAt(0).toUpperCase() + fragment.name.slice(1).split(/(?=[A-Z])/).join(" "),
    args: fragment.inputs.map(function (input) {
      return {
        type: input.type
      };
    })
  };
},
    getSigHah = function getSigHah(sig) {
  return _ethers.ethers.utils.hexDataSlice(_ethers.ethers.utils.id(sig), 0, 4);
},
    processFunctions = function processFunctions(functions) {
  return Object.keys(functions).reduce(function (acc, key) {
    var fragment = _ethers.ethers.utils.FunctionFragment.from(key);

    return _objectSpread(_defineProperty({}, getSigHah(fragment.format()), {
      source: functions[key],
      fragment: fragment
    }), acc);
  }, {});
};

var _default = function _default(provider, evaluator) {
  return (
    /*#__PURE__*/

    /**
    * Interpret calldata using radspec recursively. If the function signature is not in the package's known
    * functions, it fallbacks to looking for the function name using github.com/parity-contracts/signature-registry
    *
    * @param {address} addr The target address of the call
    * @param {bytes} data The calldata of the call
    * @param {string} [registryAddress] The registry address to lookup descriptions
    * @return {Promise<radspec/evaluator/TypedValue>}
    */
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(addr, data, registryAddress) {
        var functions, methodId, fn, registry, result, _parse, name, _ref2, results, _parse2, _name, source, fragment, ethersInterface, args, parameters;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                functions = processFunctions(_data.knownFunctions);

                if (!(10 > data.length)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", makeUnknownFunctionNode(data));

              case 3:
                // Get method ID
                methodId = data.substr(0, 10), fn = functions[methodId]; // If function is not a known function

                if (fn) {
                  _context.next = 37;
                  break;
                }

                _context.prev = 5;
                _context.t0 = _methodRegistry.default;
                _context.t1 = registryAddress;
                _context.t2 = provider;

                if (!registryAddress) {
                  _context.next = 13;
                  break;
                }

                _context.t3 = void 0;
                _context.next = 16;
                break;

              case 13:
                _context.next = 15;
                return provider.getNetwork();

              case 15:
                _context.t3 = _context.sent.chainId;

              case 16:
                _context.t4 = _context.t3;
                _context.t5 = {
                  registryAddress: _context.t1,
                  provider: _context.t2,
                  network: _context.t4
                };
                registry = new _context.t0(_context.t5);
                _context.next = 21;
                return registry.lookup(methodId);

              case 21:
                result = _context.sent;
                _parse = parse(result);
                name = _parse.name;
                return _context.abrupt("return", {
                  type: "string",
                  value: name // TODO: should we decode and print the arguments as well?

                });

              case 27:
                _context.prev = 27;
                _context.t6 = _context["catch"](5);
                _context.next = 31;
                return _ethers.ethers.utils.fetchJson("".concat(_defaults.DEFAULT_API_4BYTES, "?hex_signature=").concat(methodId));

              case 31:
                _ref2 = _context.sent;
                results = _ref2.results;

                if (!(Array.isArray(results) && 0 < results.length)) {
                  _context.next = 36;
                  break;
                }

                _parse2 = parse(results[0].text_signature), _name = _parse2.name;
                return _context.abrupt("return", {
                  type: "string",
                  value: _name
                });

              case 36:
                return _context.abrupt("return", makeUnknownFunctionNode(methodId));

              case 37:
                // If the function was found in local radspec registry. Decode and evaluate.
                source = fn.source, fragment = fn.fragment, ethersInterface = new _ethers.ethers.utils.Interface([fragment]), args = ethersInterface.decodeFunctionData(fragment.name, data), parameters = fragment.inputs.reduce(function (parameters, input, index) {
                  return _objectSpread(_defineProperty({}, "$".concat(index + 1), {
                    type: input.type,
                    value: args[index]
                  }), parameters);
                }, {});
                _context.next = 40;
                return (0, _lib.evaluateRaw)(source, parameters, {
                  provider: provider,
                  availableHelpers: evaluator.helpers.getHelpers(),
                  to: addr
                });

              case 40:
                _context.t7 = _context.sent;
                return _context.abrupt("return", {
                  type: "string",
                  value: _context.t7
                });

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 27]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.default = _default;